import { Collapse } from "react-bootstrap";
import { useToggle } from "hooks";
import { Icons } from "components";

const CollapseList = ({
  alternate,
  className,
  titleClasses,
  title,
  scrollable,
  children,
}) => {
  const [open, toggleOpen] = useToggle(true);

  return (
    <div
      className={`${
        !alternate ? "collapse_list" : "collapse_list-2"
      } ${className} ${open && "open"} `}
    >
      <div
        role="button"
        className={`collapse-header d-flex justify-content-between align-items-center`}
        onClick={toggleOpen}
      >
        <h5 className={titleClasses}>{title}</h5>
        <Icons.ArrowDown2 className={`${open && "flipped"}`} />
      </div>
      <Collapse in={open}>
        <div>
          <div
            className={`collapse-body ${scrollable ? "scrollable" : ""} mt-4`}
          >
            {children}
          </div>
        </div>
      </Collapse>
    </div>
  );
};

export default CollapseList;
